import { LitElement } from 'lit';

export const resetUploadFile = (context: LitElement, event: CustomEvent) => {
  const { detail } = event;

  context.dispatchEvent(
    new CustomEvent('personalisation-reset-upload-file', {
      composed: true,
      detail,
    }),
  );
};
